import { render, staticRenderFns } from "./LazyProductCarousel.vue?vue&type=template&id=59727de0&scoped=true"
import script from "./LazyProductCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyProductCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LazyProductCarousel.vue?vue&type=style&index=0&id=59727de0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59727de0",
  null
  
)

export default component.exports